import { t } from "ttag";

import { ADMIN_ROUTES, ROUTES } from "@/app/router";
import type { DomainRoute, ExternalLink } from "@/config/paths";
import type { Category, Subscription } from "@/shared/domains";
import {
  CATEGORY_SLUG,
  SUBSCRIPTION_STATUS,
  SUBSCRIPTION_VENDOR,
} from "@/shared/domains";

interface NavigationItem {
  path: DomainRoute | ExternalLink;
  label: string;
  subscriptionStatus: Subscription["status"][];
  needsIntakeForm?: boolean;
  disabled?: boolean;
  activeCategories: Category["slug"][];
  new?: boolean;
  external?: boolean;
  vendors?: Subscription["vendor"][];
}

const allSubscriptions = Object.values(SUBSCRIPTION_STATUS);
const allProductCategories = Object.values(CATEGORY_SLUG);
const allVendors = Object.values(SUBSCRIPTION_VENDOR);

export const getAdminNavigation = (): NavigationItem[] => [
  {
    path: ADMIN_ROUTES.COACHING.BASE,
    label: t`Coaching lab`,
    subscriptionStatus: allSubscriptions,
    activeCategories: allProductCategories,
  },
];

export const getCancelledPatientNavigation = (): NavigationItem[] =>
  [
    {
      path: ROUTES.HOME,
      label: t`Home`,
    },
    {
      path: ROUTES.MY_MEDS,
      label: t`My meds`,
    },
    {
      path: ROUTES.DOCUMENT_CENTER.OVERVIEW,
      label: t`Document center`,
    },
    {
      path: ROUTES.BILLING.OVERVIEW,
      label: t`Billing`,
    },
    {
      path: ROUTES.SHOP.OVERVIEW,
      label: t`Shop`,
      new: true,
    },
  ] as NavigationItem[];

export const getCoachingNavigation = (): NavigationItem[] => [
  {
    path: ROUTES.COACHING.OVERVIEW,
    label: t`Coaching hub`,
    subscriptionStatus: [SUBSCRIPTION_STATUS.ACTIVE],
    activeCategories: allProductCategories,
  },
  {
    path: ROUTES.BILLING.OVERVIEW,
    label: t`Billing`,
    subscriptionStatus: allSubscriptions,
    activeCategories: allProductCategories,
  },
];

export const getPatientNavigation = (): NavigationItem[] => [
  {
    path: ROUTES.HOME,
    label: t`Home`,
    subscriptionStatus: allSubscriptions,
    activeCategories: allProductCategories,
    vendors: allVendors,
  },
  {
    path: ROUTES.MY_MEDS,
    label: t`My meds`,
    subscriptionStatus: [
      SUBSCRIPTION_STATUS.ACTIVE,
      SUBSCRIPTION_STATUS.PAID_IN_HEALTHIE,
    ],
    activeCategories: allProductCategories,
    needsIntakeForm: true,
    vendors: allVendors,
  },
  {
    path: ROUTES.CONSULTATIONS.OVERVIEW,
    label: t`Consultations`,
    subscriptionStatus: [
      SUBSCRIPTION_STATUS.ACTIVE,
      SUBSCRIPTION_STATUS.PAID_IN_HEALTHIE,
    ],
    activeCategories: [CATEGORY_SLUG.WEIGHT_LOSS, CATEGORY_SLUG.MICRODOSING],
    needsIntakeForm: true,
    vendors: allVendors,
  },
  {
    path: ROUTES.COACHING.OVERVIEW,
    label: t`Coaching hub`,
    subscriptionStatus: [
      SUBSCRIPTION_STATUS.ACTIVE,
      SUBSCRIPTION_STATUS.PAID_IN_HEALTHIE,
    ],
    activeCategories: [CATEGORY_SLUG.WEIGHT_LOSS, CATEGORY_SLUG.MICRODOSING],
    vendors: allVendors,
  },
  {
    path: ROUTES.DOCUMENT_CENTER.OVERVIEW,
    label: t`Document center`,
    subscriptionStatus: allSubscriptions,
    activeCategories: allProductCategories,
    needsIntakeForm: false,
    vendors: allVendors,
  },
  {
    path: ROUTES.BILLING.OVERVIEW,
    label: t`Billing`,
    subscriptionStatus: allSubscriptions,
    activeCategories: allProductCategories,
    vendors: allVendors,
  },
  {
    path: ROUTES.SHOP.OVERVIEW,
    label: t`Shop`,
    subscriptionStatus: allSubscriptions,
    activeCategories: allProductCategories,
    new: true,
    vendors: allVendors,
  },
];
